import { useRavenPayment } from "../../../../hooks/useExternalPayment";

export const RavenPaymentTrigger = () => {
  useRavenPayment({
    allowMount: true,
  });
  return <></>;
};
